import { render, staticRenderFns } from "./recordDialog.vue?vue&type=template&id=fb488842&scoped=true"
import script from "./recordDialog.vue?vue&type=script&lang=js"
export * from "./recordDialog.vue?vue&type=script&lang=js"
import style0 from "./recordDialog.vue?vue&type=style&index=0&id=fb488842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb488842",
  null
  
)

export default component.exports